exports.default = {
  size: {
    "4": "4px",
    "8": "8px",
    "12": "12px",
    "16": "16px",
    "20": "20px",
    "24": "24px",
    "28": "28px",
    "32": "32px",
    "36": "36px",
    "40": "40px",
    "44": "44px",
    "48": "48px",
    "64": "64px",
    "80": "80px",
    "96": "96px",
    "112": "112px",
    "128": "128px",
    "144": "144px",
  },
  space: {
    "0": "0px",
    "1": "4px",
    "2": "8px",
    "3": "16px",
    "4": "24px",
    "5": "32px",
    "6": "40px",
    "7": "48px",
    "8": "64px",
    "9": "80px",
    "10": "96px",
    "11": "112px",
    "12": "128px",
  },
};
